import { FileText, Stamp, Copy } from "lucide-react";
import AISignatureDialog from "./AISignatureDialog";

const STYLES = [
  { id: "biasa", label: "Biasa", icon: FileText },
  { id: "surat_rasmi", label: "Surat Rasmi DJ", icon: Stamp },
];

export default function AIDocStylePicker({ value, onChange, onCopy, disabled, count }) {
  return (
    <div className="flex items-center gap-1.5 mb-2 flex-wrap" data-testid="ai-doc-style">
      <span className="text-[10.5px] font-semibold text-slate-500">Gaya dokumen:</span>
      <div className="flex rounded-full bg-slate-100 p-0.5">
        {STYLES.map(({ id, label, icon: Icon }) => (
          <button key={id} onClick={() => onChange(id)} data-testid={`ai-doc-style-${id}`}
            className={`flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-bold transition-colors ${value === id ? "bg-white text-fuchsia-700 shadow-sm" : "text-slate-500 hover:text-slate-700"}`}>
            <Icon className="h-3 w-3" />{label}
          </button>
        ))}
      </div>
      {value === "surat_rasmi" && <AISignatureDialog />}
      <button onClick={onCopy} disabled={disabled} data-testid="ai-copy-to-doc-btn"
        className="ml-auto flex items-center gap-1 rounded-full bg-fuchsia-600 hover:bg-fuchsia-700 text-white px-3 py-1 text-[11px] font-bold disabled:opacity-40 transition-colors">
        <Copy className="h-3 w-3" /> Salin {count > 1 ? `${count} gambar` : "gambar"} ke Word/PDF
      </button>
    </div>
  );
}
